import { KioskActionTypes, SET_KIOSK_DISPENSARY } from './types';

export function setKioskDispensary(dispensary: string): KioskActionTypes {
  return {
    type: SET_KIOSK_DISPENSARY,
    dispensary
  }
}
